import React from 'react';
import MetricCardIndustry from './MetricCardIndustry';

function MetricSectionIndustry({ bgColorClass = 'bg-transparent', data, className, titleClass = '' }) {
  return (
    <div className={`grid lg:grid-cols-4 grid-cols-1 metric lg:px-[12%] px-[6%] lg:pt-20 lg:pb-8 ${bgColorClass} ${className} lg:flex lg:justify-around`}>
      {data?.filter((elem)=>elem.title).map((metric, index) => {
        return (
          <MetricCardIndustry
            key={metric.description || index}
            bgColor={metric.bgColor}
            title={metric.title}
            description={metric.description}
            titleColor={metric?.titleColor}
            descriptionColor={metric?.descriptionColor}
            titleClass={titleClass}
          />
        );
      })}
    </div>
  );
}

export default MetricSectionIndustry;
